import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import "../../css/rightNav.css";

// Context
import { AuthContext } from "../../context/auth.context.js";

// Firebase Auth
import { getAuth, signOut } from "firebase/auth";

// ===== Styled UL =====
const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;

  li {
    padding: 0.5rem 1rem;
  }

  @media (max-width: 1024px) {
    flex-flow: column nowrap;
    background-color: #dcd8ddff;
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    padding-top: 4rem;
    transition: transform 0.3s ease-in-out;
    opacity: 0.95;
    z-index: 1050;

    li {
      padding: 1rem 2rem;
      color: #fff;
    }
  }
`;

// ===== RightNav Component =====
const RightNav = ({ open, changeStateBurger }) => {
  const navigate = useNavigate();
  const { isLoggedIn, isAdmin, authenticateUser } = useContext(AuthContext);

  // Cierra el menu burger
  const handleChangeBurger = () => {
    changeStateBurger();
  };

  // Logout
  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        authenticateUser();
        navigate("/");
        handleChangeBurger();
        console.log("Usuario deslogueado");
      })
      .catch((err) => console.log(err));
  };

  return (
    <Ul open={open} className="links">
      <li>
        <Link to="/" onClick={handleChangeBurger}>Home</Link>
      </li>
      <li>
        <Link to="/el-reto" onClick={handleChangeBurger}>Conoce El Reto</Link>
      </li>
      <li>
        <Link to="/conoce-a-carmen" onClick={handleChangeBurger}>Conoce a Carmen</Link>
      </li>
      <li>
        <Link to="/retos-anteriores" onClick={handleChangeBurger}> Retos Anteriores</Link>
      </li>
      <li>
        <Link to="/rutas-bicicletas" onClick={handleChangeBurger}>Rutas en bicicleta</Link>
      </li>
      <li>
        <Link to="/colabora" onClick={handleChangeBurger}>Colabora</Link>
      </li>
       <li>
        <Link to="/colaboradores" onClick={handleChangeBurger}>Colaboradores</Link>
      </li>
      <li>
        <Link to="/contacto" onClick={handleChangeBurger}>Contacto</Link>
      </li>
      <li>
        {/* <Link to="/gregarios" onClick={handleChangeBurger}>Gregarios</Link> */}
      </li>

      {isAdmin && (
        <li>
          <Link to="/admin" onClick={handleChangeBurger}>Admin</Link>
        </li>
      )}

      {isLoggedIn &&
        <li>
          <Link to="/" onClick={handleLogout}>Cerrar Sesión</Link>
        </li>
      }
    </Ul>
  );
};

export default RightNav;
